import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSortAmountUp, FaSortAmountDown, FaArrowRight, FaArrowLeft, FaGlassCheers, FaCheck, FaTimes } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';

const Liste_Inscription_Afterwork = ({ titre }) => {
    useAuth();
    const [participants, setParticipants] = useState([]);
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'nom', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(false);

    const user_id = localStorage.getItem('user_id');

    // Titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Afterwork";
        }
    }, [user_id]);

    // Récupération des participants
    const fetchParticipants = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');
            const url = `${process.env.REACT_APP_HOTE}/liste-participants-afterwork/?page=${currentPage}&per_page=${itemsPerPage}&search=${searchTerm}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                const data = await response.json();
                // ✅ L'API renvoie "inscriptions" -> on l'ajoute en premier
                const list = data.inscriptions || data.liste_inscriptions || data.liste || data.participants || [];
                setParticipants(list);
                setTotalItems(data.count ?? data.total ?? list.length);
                setHasMore(data.has_more || false);
            } else {
                console.error('Erreur lors de la récupération des inscriptions');
                setParticipants([]);
                setTotalItems(0);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setParticipants([]);
            setTotalItems(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchParticipants();
    }, [currentPage, itemsPerPage, searchTerm]);

    const handleRowClick = (participant) => {
        setSelectedParticipant(participant);
    };

    // Tri
    const sortedParticipants = [...participants].sort((a, b) => {
        const valA = a[sortConfig.key] ?? '';
        const valB = b[sortConfig.key] ?? '';
        if (valA < valB) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Rendu "oui / non" pour les colonnes booléennes
    const renderOuiNon = (value, ouiClass = 'bg-success', nonClass = 'bg-secondary') => {
        if (value === 'oui') {
            return (
                <span className={`badge ${ouiClass}`}>
                    <FaCheck className="mr-1" /> Oui
                </span>
            );
        }
        if (value === 'non') {
            return (
                <span className={`badge ${nonClass}`}>
                    <FaTimes className="mr-1" /> Non
                </span>
            );
        }
        return <span className="text-muted">-</span>;
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaGlassCheers size={25} className='mr-2' />
                                Inscriptions Afterwork
                            </h2>
                            <small>Gestion des participants inscrits à l'afterwork.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-afterwork`}>Afterwork</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des participants</h5>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type === 'danger' ? 'danger' : 'success'} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ message: '', type: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher par nom, prénoms, entreprise..."
                                                    className="form-control"
                                                    style={{ maxWidth: '250px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>

                                            <div className="table-" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '150px', cursor: 'pointer' }} onClick={() => handleSort('nom')}>
                                                                Nom {sortConfig.key === 'nom' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '150px', cursor: 'pointer' }} onClick={() => handleSort('prenom')}>
                                                                Prénom {sortConfig.key === 'prenom' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '130px' }}>
                                                                Téléphone
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '150px', cursor: 'pointer' }} onClick={() => handleSort('institution')}>
                                                                Entreprise {sortConfig.key === 'institution' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '110px', textAlign: 'center', cursor: 'pointer' }} onClick={() => handleSort('certifie')}>
                                                                Certifié {sortConfig.key === 'certifie' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '120px', textAlign: 'center', cursor: 'pointer' }} onClick={() => handleSort('droit_image')}>
                                                                Droit à l'image {sortConfig.key === 'droit_image' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '150px', cursor: 'pointer' }} onClick={() => handleSort('date_inscription')}>
                                                                Date d'inscription {sortConfig.key === 'date_inscription' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {sortedParticipants.length > 0 ? sortedParticipants.map((participant) => (
                                                                <tr
                                                                    key={participant.id}
                                                                    className={`bg-white ${selectedParticipant && selectedParticipant?.id === participant.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(participant)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <td>
                                                                        {participant.nom || '-'}
                                                                        <div className='lesInfos d-md-none'>
                                                                            <small>Prénom : {participant.prenom || '-'}</small><br />
                                                                            <small>Tél : {participant.telephone || '-'}</small><br />
                                                                            <small>Entreprise : {participant.institution || '-'}</small><br />
                                                                            <small>Certifié : {participant.certifie || '-'}</small><br />
                                                                            <small>Droit à l'image : {participant.droit_image || '-'}</small><br />
                                                                            <small>Inscrit le : {participant.date_inscription ? new Date(participant.date_inscription).toLocaleDateString() : 'N/A'}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">{participant.prenom || '-'}</td>
                                                                    <td className="d-none d-md-table-cell">{participant.telephone || '-'}</td>
                                                                    <td className="d-none d-md-table-cell">{participant.institution || '-'}</td>
                                                                    <td className="d-none d-md-table-cell text-center">
                                                                        {renderOuiNon(participant.certifie, 'bg-success', 'bg-alert')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell text-center">
                                                                        {renderOuiNon(participant.droit_image, 'bg-primary', 'bg-alert')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {participant.date_inscription ? new Date(participant.date_inscription).toLocaleDateString() : 'N/A'}
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center">Aucun participant inscrit</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="7" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${((currentPage - 1) * itemsPerPage) + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }
                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_Inscription_Afterwork;